export enum ReferralContactType {
  Insurance,
  NCM,
}
